<template>
  <v-card width="500" class="elevation-12">
    <v-card-text>
      <v-container fluid>
        <v-layout row justify-center class="mb-1">
          <v-icon large class="k-orange-linear-text">
            fas fa-check-double
          </v-icon>
        </v-layout>
        <v-layout class="mb-1">
          <v-flex xs12 class="f2em text-xs-center text-light k-orange-linear-text">
            {{ title }}
          </v-flex>
        </v-layout>
        <v-layout row class="mb-3 mt-3">
          <v-flex xs12>
            <span class="grey--text">
              {{ message }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout v-if="redirect" row class="mb-3 mt-3">
          <v-flex xs12>
            <v-btn
              class="k-orange-linear white--text"
              block
              large
              @click="$router.push(redirect)"
            >
              {{ redirectBtn }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      required: false,
    },
    redirectBtn: {
      type: String,
      default: 'VOLVER AL INICIO',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/SuccessView.vue